module.exports = __webpack_public_path__ + "img/account.7cc4462c.png";